export default __webpack_public_path__ + "static/media/logo_white.5cac7545.png";